import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { soportaBiometria, loginConBiometria } from '../lib/webauthn';
import PasswordField from './shared/PasswordField';
import RecuperarPasswordModal from './RecuperarPasswordModal';
import './Login.css';

export default function Login() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [bioLoading, setBioLoading] = useState(false);
  const [error,    setError]    = useState(null);
  const [showRecuperar, setShowRecuperar] = useState(false);
  const [puedeBiometria, setPuedeBiometria] = useState(false);

  // Detectar soporte biométrico al montar.
  useEffect(() => {
    setPuedeBiometria(soportaBiometria());
  }, []);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError('Email o contraseña incorrectos');
    setLoading(false);
  }

  async function handleBio() {
    if (!email) {
      setError('Ingresa tu email primero para usar Face ID/huella.');
      return;
    }
    setBioLoading(true);
    setError(null);
    const r = await loginConBiometria(email.trim());
    if (!r.ok) {
      setError(r.error || 'No se pudo entrar con biometría.');
    }
    // Si OK, AuthContext detecta la sesión nueva y rerenderiza al panel.
    setBioLoading(false);
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        {/* Isotipo + wordmark */}
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <img src="/vera.png" alt="Vera.ia" width={72} height={72} style={{ display: 'block' }} />
        </div>
        <div className="login-logo">
          Vera <span>IA</span>
        </div>
        <p className="login-sub">Panel de gestión · Acceso ejecutivos</p>

        <form onSubmit={handleLogin} className="login-form">
          <div className="login-field">
            <label className="login-label">Email</label>
            <input
              type="email"
              className="login-input"
              placeholder="tucorreo@inmobiliaria.cl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>

          <div className="login-field">
            <label className="login-label">Contraseña</label>
            <PasswordField
              inputClassName="login-input"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <p className="login-error">{error}</p>}

          <button type="submit" className="login-btn" disabled={loading || bioLoading}>
            {loading ? (
              <span className="login-spinner" />
            ) : (
              'Ingresar'
            )}
          </button>
        </form>

        {puedeBiometria && (
          <>
            <div className="login-divider">
              <span>o entra con</span>
            </div>
            <button
              type="button"
              className="login-bio-btn"
              onClick={handleBio}
              disabled={bioLoading || loading}
              title="Face ID, Touch ID, huella o Windows Hello según tu dispositivo"
            >
              {bioLoading ? (
                <span className="login-spinner login-spinner--dark" />
              ) : (
                <>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M9 4H5a2 2 0 0 0-2 2v3" />
                    <path d="M15 4h4a2 2 0 0 1 2 2v3" />
                    <path d="M9 20H5a2 2 0 0 1-2-2v-3" />
                    <path d="M15 20h4a2 2 0 0 0 2-2v-3" />
                    <circle cx="12" cy="11" r="2.5" />
                    <path d="M9 16c0-1.5 1.4-2.5 3-2.5s3 1 3 2.5" />
                  </svg>
                  Entrar con biometría
                </>
              )}
            </button>
          </>
        )}

        <button
          type="button"
          className="login-forgot login-forgot-btn"
          onClick={() => setShowRecuperar(true)}
        >
          ¿Olvidaste tu contraseña?
        </button>
      </div>

      {showRecuperar && (
        <RecuperarPasswordModal
          emailInicial={email}
          onClose={() => setShowRecuperar(false)}
        />
      )}
    </div>
  );
}
